import {useMemo} from 'react';
import {useDocumentContext} from '@/components/document/context';
import SectionTitle from '@/components/section-title';
import {Group} from './group';
import {useDocumentMountEvent} from './hooks/use-document-mount-event';

export const Section = () => {
  const {valueResolver, visibilitySet} = useDocumentContext();
  const {documentModel: model, currentSectionId: currentSection} = useDocumentContext();

  const section = useMemo(() => model.sections.find(section => section.id === currentSection), [model, currentSection]);

  const groups = useMemo(() => section?.groups.flatMap(group => ('type' in group ? group.rows : [group])), [section]);

  const extraSectionsToDisplay = useMemo(
    () => model.sections.filter(extraSection => section?.displayWith.includes(extraSection.id)),
    [model, section?.displayWith],
  );

  const extraGroupsToDisplay = useMemo(
    () =>
      extraSectionsToDisplay.map(extraSection =>
        extraSection.groups.flatMap(group => ('type' in group ? group.rows : [group])),
      ),
    [extraSectionsToDisplay],
  );

  useDocumentMountEvent(section?.onMount);

  return (
    <>
      {section && (
        <section data-testid={section.id} className="flex flex-col gap-6">
          <SectionTitle data-testid={`${section.id}-title`}>
            {valueResolver(section.title, {visibilitySet})}
          </SectionTitle>

          {groups?.map(group => group.visible && <Group sectionId={section.id} key={group.id} group={group} />)}
        </section>
      )}

      {extraSectionsToDisplay &&
        extraSectionsToDisplay.map((extraSection, index) => (
          <section key={extraSection.id} data-testid={extraSection.id} className="mt-14 flex flex-col gap-6">
            <SectionTitle data-testid={`${extraSection.id}-title`} className={extraSection.hidden ? 'hidden' : ''}>
              {valueResolver(extraSection.title, {visibilitySet})}
            </SectionTitle>

            {extraGroupsToDisplay[index].map(
              group => group.visible && <Group sectionId={extraSection.id} key={group.id} group={group} />,
            )}
          </section>
        ))}
    </>
  );
};
